const iframeThreeDs = (resAuthenticate) => {
  return `
    <html>
      <body>
        <form name="sendFingerprint" action="${resAuthenticate.methodURL}" method="post" style="display: none">
          <input name="threeDSMethodData" value="${resAuthenticate.threeDSMethodData}" />
        </form>
      </body>
      <script type="text/javascript">
        setTimeout(function() {
          document.createElement('form').submit.call(document.sendFingerprint);
        }, 100);
      <\/script>
    </html>
  `;
};

const iframeThreeDsChallenge = (res) => {
  return `
    <html>
      <body>
        <form name="sendChallenge" action="${res.data.acsURL}" method="post" style="display: none">
          <input name="creq" value="${res.data.creq}" />
        </form>
      </body>
      <script type="text/javascript">
        setTimeout(function() {
          document.createElement('form').submit.call(document.sendChallenge);
        }, 100);
      <\/script>
    </html>
  `;
};

export { iframeThreeDs, iframeThreeDsChallenge };
